import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { TRule } from 'utils'

export const getRangeTooltipMessage = (
  rules: Record<string, TRule>,
  attributeName: string,
  field: 'range_min' | 'range_max' | 'range_avg'
): ReactNode => {
  if (!rules) return null
  const rule = rules[attributeName]
  if (!rule) return null

  if (field === 'range_avg') {
    // For average field
    const recommendedMin =
      rule.warnBelow !== undefined ? rule.warnBelow : rule.min
    const recommendedMax =
      rule.warnAbove !== undefined ? rule.warnAbove : rule.max
    const hardMin = rule.hardMin !== undefined ? rule.hardMin : rule.min
    const hardMax = rule.hardMax !== undefined ? rule.hardMax : rule.max

    const showExtraRange =
      (rule.warnBelow !== undefined &&
        rule.hardMin !== undefined &&
        rule.warnBelow !== rule.hardMin) ||
      (rule.warnAbove !== undefined &&
        rule.hardMax !== undefined &&
        rule.warnAbove !== rule.hardMax)

    return (
      <Box sx={{ textAlign: 'center', maxWidth: 220 }}>
        <Typography variant="body2">
          Recommended average: {recommendedMin} – {recommendedMax}
        </Typography>
        {showExtraRange ? (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Values between {hardMin} – {hardMax} are allowed but may be less
            ideal.
          </Typography>
        ) : null}
      </Box>
    )
  }

  const isMin = field === 'range_min'

  // For min/max fields
  if (isMin) {
    // Min field logic
    const recommendedMin =
      rule.warnBelow !== undefined ? rule.warnBelow : rule.min
    const hardMin = rule.hardMin !== undefined ? rule.hardMin : rule.min

    const showExtraMin =
      rule.warnBelow !== undefined &&
      rule.hardMin !== undefined &&
      rule.warnBelow !== rule.hardMin

    return (
      <Box sx={{ textAlign: 'center', maxWidth: 220 }}>
        <Typography variant="body2">
          Recommended minimum: {recommendedMin}
        </Typography>
        {showExtraMin ? (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Values down to {hardMin} are allowed but may be less ideal.
          </Typography>
        ) : null}
      </Box>
    )
  } else {
    // Max field logic
    const recommendedMax =
      rule.warnAbove !== undefined ? rule.warnAbove : rule.max
    const hardMax = rule.hardMax !== undefined ? rule.hardMax : rule.max

    const showExtraMax =
      rule.warnAbove !== undefined &&
      rule.hardMax !== undefined &&
      rule.warnAbove !== rule.hardMax

    return (
      <Box sx={{ textAlign: 'center', maxWidth: 220 }}>
        <Typography variant="body2">
          Recommended maximum: {recommendedMax}
        </Typography>
        {showExtraMax ? (
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Values up to {hardMax} are allowed but may be less ideal.
          </Typography>
        ) : null}
      </Box>
    )
  }
}
